const aboutContent = {
    image: {
        src: "/images/home/about/TeacherAbout.webp",
        alt: "Teacher About image",
    },
    header: {
        title: "مستر شريف اسامه",
        highlight: "عن",
    },
    description: `لوحدك هتوصل بس مع بعض اسرع`,
    button: {
        text: "احجز الأن",
        link: "/redeem",
    },
    waveImage: {
        src: "/images/home/about/aboutSectionWave.webp",
        alt: "section wave image",
    },
};

export default aboutContent;
